import type { Visit } from "@gettactic/api";
import { useOfficesQuery } from "@gettactic/hooks";
import { useCallback } from "react";
import { printVisitorBadge } from "@/features/visitors/components/VisitorBadgePrint";

/**
 * Print a visit's badge with the date stamped in the visit's office time
 * zone, so every "Print badge" entry point prints the same time.
 */
export const useVisitorBadgePrinter = (): ((visit: Visit) => void) => {
  const { data: officesData } = useOfficesQuery();
  return useCallback(
    (visit: Visit) => {
      void printVisitorBadge(visit, {
        timeZone: visit.office_id
          ? officesData?.byId[visit.office_id]?.time_zone
          : undefined
      });
    },
    [officesData]
  );
};
